import { getPersonAttributes } from '.';

export const testPincodePersonData = {
  status: {
    result: 'success',
    timestamp: '2021-05-05 18:07:02',
    code: 1,
    time: 0.5742380619049072,
  },
  params: {
    pincode: 'PINCODE-PERSON',
    token: 'VW_DDB_FORM_NOCOMPRA',
  },
  content: [
    {
      attributes: [...getPersonAttributes()]
    },
  ],
};
